import { render, staticRenderFns } from "./decNotice.vue?vue&type=template&id=6033cece&scoped=true&"
import script from "./decNotice.vue?vue&type=script&lang=js&"
export * from "./decNotice.vue?vue&type=script&lang=js&"
import style0 from "./decNotice.vue?vue&type=style&index=0&id=6033cece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033cece",
  null
  
)

export default component.exports